import { render, staticRenderFns } from "./BCRadioSettings.vue?vue&type=template&id=2f31402a&scoped=true"
import script from "./BCRadioSettings.vue?vue&type=script&lang=js"
export * from "./BCRadioSettings.vue?vue&type=script&lang=js"
import style0 from "./BCRadioSettings.vue?vue&type=style&index=0&id=2f31402a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f31402a",
  null
  
)

export default component.exports